import React, { useImperativeHandle } from "react";
import InputMask from "react-input-mask";
import NumberFormat from "react-number-format";
// @ts-ignore
import stringMask from "string-mask";
import { inputTypes } from "../../../common/types";

type InputProps = {
  onChangeValue?: (value: string) => void,
  mask?: string,
  label?: string,
  definition?: string,
  required?: boolean,
  labelInfoIcon?: React.ReactElement,
  type: inputTypes,
  className?: string,
  error?: any,
  isError?: boolean,
  currencyformat?: any,
  decimalScale?: number,
  defaultValue?: any,
  currencyicon?: boolean,
  rightIcon?: React.ReactNode,
  rightOutsideIcon?: React.ReactNode,
  leftIcon?: React.ReactNode,
  rightButton?: React.ReactNode,
  labelHelper?: string,
  successText?: string,
  value?: string | number |any,
  onChange?: (ev: any) => void,
  name?: string,
  placeholder?: string,
  rightIconClass?: string
  onValueChange?: any,
  containerClassName?: string,
  disabled?: boolean,
  loading?:boolean,
  currencySymbol?:string,
  maxLength?:number
}

const Input = React.forwardRef(({ ...props }: InputProps, ref) => {


  useImperativeHandle(ref, () => ({

    setValue(val: string) {
      setInputValue(val);
    }
  }));

  const setInputValue = (val: string) => {

    if (props.onChangeValue) {
      if (props.mask) {
        var mask = new stringMask(props.mask, {}); //optionsObject is optional
        var maskedValue = mask.apply(val);
        props.onChangeValue(maskedValue);
      } else {
        props.onChangeValue(val);
      }
    } 
  }
  const getLoading =()=>{

    return(
      <div className="absolute z-2 right-2 top-2 ">
      <svg
        className={`animate-spin -ml-1 mr-3 h-5 w-5 text-black`}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      </div>
    );
  }

  return (
    <div className={props.containerClassName}>
      {props.label && (
        <div className="flex items-center text-sm  mb-1">
          <label className="block text-contrast-70 whitespace-nowrap cursor-default">
            {props.label}
          </label>
          {props.definition && (
            <p className="block text-contrast-70 text-darkblue-400 whitespace-nowrap ml-1">
              ({props.definition})
            </p>
          )}
          {props.required && <p className="block text-contrast-70">*</p>}

          {props.labelInfoIcon ? props.labelInfoIcon : null}
        </div>
      )}
      <div className="flex items-center">
        <>

          {props.leftIcon && (
            <div className="absolute z-full left-6 top-2  text-contrast-50">
              {props.leftIcon}
            </div>
          )}

          {props.type === "textarea" ? (
            <textarea className={`${props.className} ${(props.error || props.isError) ? "!border-error " : ""}`} {...props}></textarea>
          ) : props.mask ? (
            <div className="w-full relative">

              <InputMask
                autoComplete="none"
                mask={props.mask}
                maskChar={null}
                {...props}
                className={`text-sm text-contrast-90 border-b p-2 bg-contrast-10 border-gray-300 focus:outline-none w-full ${props.className
                  } ${(props.error || props.isError) ? "!border-error" : ""} h-9 rounded-md-custom`}
              />

              {props.rightIcon && (
                <div className={`absolute z-2 right-6 top-1.5  text-contrast-50 ${props.rightIconClass}`}>
                  {props.rightIcon}
                </div>
              )}
                   {props.loading && getLoading()}

            </div>

          ) : props.currencyformat ? (
            <div className="w-full relative">
              <NumberFormat
                {...props}
                type="text"
                thousandSeparator={true}
                decimalSeparator={"."}
                decimalScale={props.decimalScale || 2}
                fixedDecimalScale={true}
                allowNegative={false}
                defaultValue={props.defaultValue}
                className={`border-b text-contrast-90 text-sm rounded-md-custom leading-4 p-2 bg-contrast-10   mr-2 focus:outline-none w-full  ${props.className
                  } ${(props.error || props.isError)
                    ? "!border-error"
                    : (props.error || props.isError)
                      ? "!border-error"
                      : "border-gray-300"
                  }   
            `}
              />
              {props.currencyicon && (
                <span className="absolute z-2 right-6 top-2  text-contrast-50">
                  {props.currencySymbol || "₺"}
                </span>
              )}
              {props.loading && getLoading()}
            </div>
          ) : (
            <div className="w-full relative">
              <input 
                {...props}

                className={`border-b text-contrast-90 text-sm rounded-md-custom leading-3 h-9 p-2 bg-contrast-10 border-gray-300 mr-2 focus:outline-none w-full ${props.className
                  } ${(props.error || props.isError) ? "!border-error" : ""}`}
              />
              {props.currencyicon && (
                <span className="absolute z-2 right-6 top-1.5  text-contrast-50">
               {props.currencySymbol || "₺"}
                </span>
              )}
              {props.rightIcon && (
                <div className={`absolute z-2 right-6 top-1.5  text-contrast-50 ${props.rightIconClass}`}>
                  {props.rightIcon}
                </div>
              )}
            </div>
          )}
        </>
        {props.rightOutsideIcon && (
          <div className="ml-2 z-2 text-contrast-50 color-primary-color h-full bg-contrast-10 rounded-md h-9 flex items-center w-[36px] justify-center">
            {props.rightOutsideIcon}
          </div>
        )}
        {props.rightButton && (
          <div className="">
            {props.rightButton}
          </div>
        )}

      </div>
      {props.labelHelper && (
        <p className="mt-2 text-2xs text-contrast-70">{props.labelHelper}</p>
      )}
      {(props.error && typeof props.error !== "boolean") && (
        <p className="mt-2 text-sm text-error-text">{props.error}</p>
      )}
      {props.successText && (
        <p className="mt-2 text-sm text-success-text">{props.successText}</p>
      )}
    </div>
  );
})

export default Input;